import { createRoot } from "react-dom/client"
import { App } from "./App"
import { ToastProvider } from "./components/Toast"
import { ColorContext, useColorProvider } from "./hooks/useColor"

function Root() {
	const colorCtx = useColorProvider()

	return (
		<ColorContext value={colorCtx}>
			<ToastProvider>
				<App />
			</ToastProvider>
		</ColorContext>
	)
}

function start() {
	const rootElement = document.getElementById("root")
	if (!rootElement) return
	const root = createRoot(rootElement)
	root.render(<Root />)
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", start)
} else {
	start()
}
